export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/CNBC.5683a753.svg","height":58,"width":79};